import React from "react";

import { DriverTermsAndConditionsType } from "@daytrip/legacy-enums";
import { format } from "date-fns";
import Markdown from "markdown-to-jsx";

import { InfoModal } from "@components/modals/InfoModal/InfoModal";
import { ModalSize } from "@components/modals/Modal/Modal.types";
import { Headline } from "@components/typography/Headline/Headline";

import { LoaderWithLabel } from "../../../../components/LoaderWithLabel/LoaderWithLabel";
import { useDriverTermsAndConditions } from "../../hooks/useDriverTermsAndConditions";

import styles from "./DriverTermsAndConditionsModal.sass";

export type DriverTermsAndConditionsModalProps = {
    type: DriverTermsAndConditionsType | null;
    onClose: () => void;
};

export const DriverTermsAndConditionsModal: React.FC<DriverTermsAndConditionsModalProps> = ({ type, onClose }) => {
    const { data: termsAndConditions } = useDriverTermsAndConditions(type);

    return (
        <InfoModal isOpen={!!type} onClose={onClose} size={ModalSize.ExtraLarge}>
            {termsAndConditions ? (
                <div>
                    <Headline rank={2}>
                        {type === DriverTermsAndConditionsType.TermsAndConditions &&
                            "Daytrip Terms & Conditions for drivers"}
                        {type === DriverTermsAndConditionsType.PrivacyPolicy && "Daytrip Privacy Policy for drivers"}
                    </Headline>
                    <div className="mb-4">
                        Updated as of {format(new Date(termsAndConditions.createdAt), "MMMM d, Y")}
                    </div>
                    <div className={styles.content}>
                        <Markdown>{termsAndConditions.text.replace(/([^\n])\n(?=[^\n])/g, "$1  \n")}</Markdown>
                    </div>
                </div>
            ) : (
                <LoaderWithLabel label="Loading terms and conditions..." />
            )}
        </InfoModal>
    );
};
